import { render, staticRenderFns } from "./SetFloatingPage.vue?vue&type=template&id=060473b1&scoped=true"
import script from "./SetFloatingPage.vue?vue&type=script&lang=js"
export * from "./SetFloatingPage.vue?vue&type=script&lang=js"
import style0 from "./SetFloatingPage.vue?vue&type=style&index=0&id=060473b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060473b1",
  null
  
)

export default component.exports